import { msg } from "@lingui/core/macro";

export const vehicleCountAtLeastOneRuleMessages = {
	name: msg({ message: "Vehicle Count At Least One" }),
	description: msg({ message: "Ensures a permit has at least one vehicle" }),
	errors: {
		noVehicles: msg({ message: "There must be at least one vehicle on a permit" }),
	},
} as const;
